import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { IdentificacionComponent, validar as validarIdentificacion } from "./identificacion";

type Entity = models.ChoferRuta;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un ChoferRuta
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Nombre: validation.required,
        Identificacion: validation.subrule(validarIdentificacion)
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class ChoferRutaFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Identificacion = getField(IdentificacionComponent);

        const CpSatMunicipioSelector = getField(selectores.CpSatMunicipioSelector);
        const CpSatLocalidadSelector = getField(selectores.CpSatLocalidadSelector);
        const CpSatColoniaSelector = getField(selectores.CpSatColoniaSelector);

        return (
            <div>
                <kea.Title titulo="ChoferRuta" onRegresar={() => history.go("/catalogos/ChoferRuta")} />
                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                ])}
                <Identificacion field="Identificacion" />,

                {kea.autogrid(4, [
                    <Text field="DireccionCalle" label="Calle" />,
                    <Text field="DireccionNumExt" label="Numero exterior" />,
                    <Text field="DireccionNumInt" label="Numero interior" />,

                    <CpSatMunicipioSelector field="IdSatMunicipio" label="Municipio Sat" />,
                    <CpSatLocalidadSelector field="IdLocalidadSat" label="Localidad Sat" />,
                    <CpSatColoniaSelector field="IdColoniaSat" label="Colonia Sat" />,
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const ChoferRutaForm = componentToRx(ChoferRutaFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/choferruta/edit/form.tsx